import { useErrorStore } from '../../../zustand/error-boundary/use-error-boundary-store'
import { useHistory } from 'react-router-dom'
import ErrorBoundary from '..'
import { useBrowserStore } from '../../../zustand/browser-store/use-browser-store'

const ErrorBoundaryHoc = ({ children }) => {
  const setError = useErrorStore((state) => state.setError)
  const setInfo = useErrorStore((state) => state.setInfo)
  const history = useHistory()
  const { isProdOrStaging } = useBrowserStore()
  return (
    <ErrorBoundary
      setError={setError}
      setInfo={setInfo}
      history={history}
      isProdOrStaging={isProdOrStaging}
    >
      {children}
    </ErrorBoundary>
  )
}

export default ErrorBoundaryHoc
